import { LineChart } from "./Charts/LineChart";


type Props = {
  refer: any;
  data?: any;
};

const NumberOfMentions: any = ({ refer, data }: Props) => {

  return (
    <div className={refer == "single" ? "" : "white-block"}>
      { data && <div>
           <LineChart graphData={data} refer={refer}/>
      </div>}
    </div>
  );
};

export default NumberOfMentions;
